import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=ea6410a4&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=ts&"
export * from "./PageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=ea6410a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6410a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ea6410a4', component.options)
    } else {
      api.reload('ea6410a4', component.options)
    }
    module.hot.accept("./PageTitle.vue?vue&type=template&id=ea6410a4&scoped=true&", function () {
      api.rerender('ea6410a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/PageTitle.vue"
export default component.exports